import type { FC, ReactNode } from "react";
import { useState } from "react";

import { Stack } from "@similarweb/ui-components/foundations";

import { CollapsibleSectionHeader } from "./CollapsibleSectionHeader";

interface ICollapsibleSectionProps {
    title: string;
    margin: string;
    children: ReactNode;
    defaultExpanded?: boolean;
}

export const CollapsibleSection: FC<ICollapsibleSectionProps> = ({
    title,
    children,
    defaultExpanded = true,
    margin,
}) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    return (
        <Stack
            width="100%"
            flex={isExpanded ? "1" : "none"}
            data-automation="collapsible-section"
        >
            <CollapsibleSectionHeader
                title={title}
                isExpanded={isExpanded}
                onToggle={() => setIsExpanded(!isExpanded)}
            />
            {isExpanded ? (
                <Stack
                    data-automation="collapsible-section-content"
                    margin={margin}
                    gap="15px"
                    width="100%"
                    flex="1"
                    overflow="auto"
                >
                    {children}
                </Stack>
            ) : null}
        </Stack>
    );
};
